import React, { useContext } from "react";
import EstimateQuotesAwaiting from "./estimate_status/EstimateQuotesAwaiting";
import EstimateQuotesReceived from "./estimate_status/EstimateQuotesReceived";
import EstimateBooked from "./estimate_status/EstimateBooked";
import EstimateCancelled from "./estimate_status/EstimateCancelled";
import EstimateCompleted from "./estimate_status/EstimateCompleted";
import DashboardContext from "../../context/dashboard/DashboardContext";
export function Move(props) {
  const { setMoveDateInfo } = props;
  const estimateStatus = parseInt(props.data.estimate_status);
  const dashboardContext = useContext(DashboardContext);
  switch (estimateStatus) {
    case 1: // awaiting approval
    case 2: // reviewed and awaiting
      return (
        <EstimateQuotesAwaiting
          data={props.data}
          estimateStatus={estimateStatus}
          updateMoveDateInfo={(params) => {
            setMoveDateInfo(params);
            dashboardContext.refresh();
          }}
        />
      );
    case 3: // quotes received
      return (
        <EstimateQuotesReceived
          data={props.data}
          updateMoveDateInfo={(params) => {
            setMoveDateInfo(params);
            dashboardContext.refresh();
          }}
        />
      );
    case 4: // booked
    case 5: // booked and in-transit
      return (
        <EstimateBooked
          data={props.data}
          setProgressModal={props.setProgressModal}
          setListOfGoods={props.setListOfGoods}
        />
      );
    case 6: //completed
      return (
        <EstimateCompleted
          data={props.data}
          setListOfGoods={props.setListOfGoods}
        />
      );
    case 7: //cancelled
    case 8: //cancelled
    case 9: //cancelled
    case 10: //cancelled
      return (
        <EstimateCancelled
          data={props.data}
          cancelStatus={estimateStatus}
          setListOfGoods={props.setListOfGoods}
        />
      );
    default:
      return <></>;
  }
}
